import React, { useEffect } from 'react';
import { parseCookies } from 'nookies';
import { useRouter } from 'next/router';

const locales = [
    'ar',
    'zh',
    'de',
    'fr',
    'en',
    'es',
    'hu',
    'it',
    'ja',
    'ko',
    'ms',
    'nl',
    'pt',
    'ru',
];

/*


il ya un problème que je n'arrive pas, ne peux pas résoudre avec nextjs et la locale
la premiere fois qu'on vient sur le site, si il n'y a pas la langue dans l'url,
cela va prendre en compte la locale par défaut que j'ai setté dans la config ('fr').
Sauf, quand on arrive sur la page d'accueil

Quand on arrive sur la page d'accueil (https://biodegustation.foound.in), si on a setté un cookie NEXT_LOCAL=it
alors nextjs va rediriger vers https://biodegustation.foound.in/it

nextjs ne regarde pas le cookie si on arrive sur https://biodegustation.foound.in/contact,
aussi il va utilise la locale "fr"

c'est un comportement volontaire de leeur part
https://nextjs.org/docs/advanced-features/i18n-routing#leveraging-the-next_locale-cookie



*/

function App(props) {
    const router = useRouter();

    useEffect(() => {
        if (
            document.location.pathname &&
            document.location.pathname.length > 3
        ) {
            //console.log('AAAAAAAAAAA');
            //console.log(document.location.pathname);
            const tmp = document.location.pathname.substring(1, 3);
            const tmp1 = document.location.pathname.substring(3, 4);
            //console.log(tmp);
            //console.log(tmp1);

            if (tmp1 === '/' && locales.includes(tmp)) {
                //console.log('BBBBBBBBBB');
            } else {
                //console.log('CCCCCCCCCC');
                const cookies = parseCookies();
                //console.log(cookies);

                if (cookies && cookies.NEXT_LOCALE) {
                    console.log(cookies.NEXT_LOCALE);
                    console.log('DDDDDDDDDD');
                    console.log(router);

                    document.location.href = `/${cookies.NEXT_LOCALE}${router.asPath}`;
                }
            }
        }
    }, []);

    return false;
}

export default App;
